/* AXION STUDIO - SHOPIFY THEME JS - VOL II */
(function() {
  'use strict';

  /* SCROLL PROGRESS BAR */
  var progressBar = document.createElement('div');
  progressBar.className = 'scroll-progress';
  document.body.insertBefore(progressBar, document.body.firstChild);
  window.addEventListener('scroll', function() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    progressBar.style.transform = 'scaleX(' + (max > 0 ? window.scrollY / max : 0) + ')';
  }, { passive: true });

  /* HERO H1 LINE REVEAL - clip-reveal via .in class (CSS handles translateY) */
  var heroLines = document.querySelectorAll('.hero .split-line');
  heroLines.forEach(function(line, i) {
    setTimeout(function() { line.classList.add('in'); }, 200 + i * 200);
  });

  /* CUSTOM CURSOR */
  var cursor = document.getElementById('cursor');
  if (cursor && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
    var mx = 0, my = 0, cx = 0, cy = 0, cursorVisible = false;
    window.addEventListener('mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
      if (!cursorVisible) { cursor.style.opacity = '1'; cursorVisible = true; }
    });
    function tick() {
      cx += (mx - cx) * 0.18;
      cy += (my - cy) * 0.18;
      cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%) rotate(45deg)';
      requestAnimationFrame(tick);
    }
    cursor.style.opacity = '0';
    cursor.style.transition = 'opacity 300ms, width 220ms cubic-bezier(0.16,1,0.3,1), height 220ms cubic-bezier(0.16,1,0.3,1), background 220ms';
    tick();

    document.querySelectorAll('[data-cursor]').forEach(function(el) {
      var type = el.dataset.cursor || 'hover';
      el.addEventListener('mouseenter', function() { cursor.classList.add(type); });
      el.addEventListener('mouseleave', function() { cursor.classList.remove('hover', 'hover-red'); });
    });

    /* Magnetic pull on buttons */
    document.querySelectorAll('.btn-ink, .btn-red, .btn-ghost').forEach(function(btn) {
      btn.addEventListener('mouseenter', function() { cursor.classList.add('hover'); });
      btn.addEventListener('mouseleave', function() {
        cursor.classList.remove('hover', 'hover-red');
        btn.style.transform = '';
      });
      btn.addEventListener('mousemove', function(e) {
        var r = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        btn.style.transform = 'translate(' + (dx * 0.08) + 'px,' + (dy * 0.08) + 'px)';
      });
    });
  }

  /* SCROLLED NAV */
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function() { nav.classList.toggle('scrolled', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* REVEAL ON SCROLL */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    document.querySelectorAll('.reveal').forEach(function(el) { io.observe(el); });
  } else {
    /* No IntersectionObserver support: never leave content hidden */
    document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('in'); });
  }

  /* SAFETY NET — never leave .reveal content stuck invisible.
     Additive only (only adds .in): fixes background-tab opens (Ctrl/Cmd-click),
     throttled transitions, and slow/failed JS. Reveals only elements currently
     in view so scroll-reveal for below-the-fold content is preserved. */
  function axRevealInView() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.reveal:not(.in)').forEach(function(el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) { el.classList.add('in'); }
    });
  }
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) { requestAnimationFrame(axRevealInView); }
  });
  setTimeout(axRevealInView, 1800);

  /* 3D TILT - art cards */
  document.querySelectorAll('.art-card').forEach(function(card) {
    card.addEventListener('mousemove', function(e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width  - 0.5;
      var y = (e.clientY - r.top)  / r.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg) scale(1.02)';
    });
    card.addEventListener('mouseleave', function() { card.style.transform = ''; });
  });

  /* 3D TILT - poster */
  var poster = document.getElementById('poster');
  if (poster) {
    poster.addEventListener('mousemove', function(e) {
      var r = poster.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width  - 0.5;
      var y = (e.clientY - r.top)  / r.height - 0.5;
      poster.style.transform = 'perspective(1200px) rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 8) + 'deg)';
    });
    poster.addEventListener('mouseleave', function() { poster.style.transform = ''; });
  }

  /* HERO PARALLAX - ghost mark */
  var heroMarkBg = document.querySelector('.hero-mark-bg');
  if (heroMarkBg) {
    window.addEventListener('scroll', function() {
      if (window.scrollY < window.innerHeight) {
        var y = window.scrollY * 0.15;
        heroMarkBg.style.transform = 'translateY(calc(-50% + ' + y + 'px))';
      }
    }, { passive: true });
  }

  /* POSTER AUTO-CYCLE */
  var posterWrap = document.getElementById('posterWrap');
  if (posterWrap) {
    var positions = posterWrap.querySelectorAll('.pos');
    var dots = posterWrap.querySelectorAll('.dot-sel');
    var currentPos = 0;
    var cycleInterval;
    function showPos(idx) {
      positions.forEach(function(p, i) { p.classList.toggle('active', i === idx); });
      dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
      currentPos = idx;
    }
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        clearInterval(cycleInterval);
        showPos(i);
        startCycle();
      });
    });
    function startCycle() {
      cycleInterval = setInterval(function() {
        showPos((currentPos + 1) % positions.length);
      }, 3400);
    }
    if (positions.length > 1) startCycle();
  }

  /* COUNT-UP - about stats */
  if ('IntersectionObserver' in window) {
    /* prefers-reduced-motion: skip the animation entirely so the canonical
       value (e.g. 200 GSM, From £32.99) is the FIRST thing the user reads.
       Also avoids the brief "From £18.36" mid-flight which violates the
       HARD RULE price truth-table. */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var statsIO = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) return;
        var span = e.target;
        var raw = span.textContent.trim();
        var numMatch = raw.match(/[\d.]+/);
        if (!numMatch) { statsIO.unobserve(span); return; }
        var target = parseFloat(numMatch[0]);
        var decPlaces = (numMatch[0].indexOf('.') >= 0) ? numMatch[0].split('.')[1].length : 0;
        var prefix = raw.slice(0, numMatch.index);
        var suffix = raw.slice(numMatch.index + numMatch[0].length);
        if (reduceMotion) {
          /* respect user preference: snap to canonical value */
          span.textContent = prefix + (decPlaces === 0 ? Math.round(target) : target.toFixed(decPlaces)) + suffix;
          statsIO.unobserve(span);
          return;
        }
        /* otherwise count from 88% of target (not 0) to avoid showing
           absurdly low intermediate values like "111 GSM" or "From £18.36" */
        var startVal = target * 0.88;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var prog = Math.min((ts - startTime) / 900, 1);
          var ease = 1 - Math.pow(1 - prog, 3);
          var val = startVal + (target - startVal) * ease;
          span.textContent = prefix + (decPlaces === 0 ? Math.round(val) : val.toFixed(decPlaces)) + suffix;
          if (prog < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        statsIO.unobserve(span);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.about-stat .n').forEach(function(n) { statsIO.observe(n); });
  }

  /* STAGGER GRID REVEALS */
  if ('IntersectionObserver' in window) {
    var gridIO = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) return;
        var children = e.target.querySelectorAll('.art-card, .tee-card, .sys-card, .coming-card, .testi-card');
        children.forEach(function(child, i) {
          child.style.opacity = '0';
          child.style.transform = 'translateY(24px)';
          child.style.transition = 'opacity 600ms cubic-bezier(0.16,1,0.3,1), transform 600ms cubic-bezier(0.16,1,0.3,1)';
          child.style.transitionDelay = (i * 55) + 'ms';
          setTimeout(function() {
            child.style.opacity = '1';
            child.style.transform = '';
          }, 80 + i * 55);
        });
        gridIO.unobserve(e.target);
      });
    }, { threshold: 0.05 });
    document.querySelectorAll('.art-grid, .tees-grid, .sys-grid, .coming-grid, .testi-grid').forEach(function(g) {
      gridIO.observe(g);
    });
  }

  /* FAQ ACCORDION */
  document.querySelectorAll('.faq-q').forEach(function(q) {
    q.addEventListener('click', function() {
      var item = q.parentElement;
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* MOBILE NAV */
  var burger = document.getElementById('navBurger');
  var mobileNav = document.getElementById('navMobile');
  if (burger && mobileNav) {
    burger.addEventListener('click', function() {
      var open = mobileNav.classList.toggle('open');
      burger.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        mobileNav.classList.remove('open');
        burger.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* WALL ART SERIES FILTER */
  var filterPills = document.querySelectorAll('.filter-pill');
  if (filterPills.length) {
    filterPills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var series = pill.dataset.series;
        filterPills.forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');
        document.querySelectorAll('.art-card').forEach(function(card) {
          card.classList.toggle('art-hidden', series !== 'all' && card.dataset.series !== series);
        });
      });
    });
  }

  /* EMAIL CAPTURE HELPER */
  function captureEmail(email, source, onDone) {
    var stored = JSON.parse(localStorage.getItem('axion_emails') || '[]');
    if (stored.indexOf(email) === -1) stored.push(email);
    localStorage.setItem('axion_emails', JSON.stringify(stored));
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    body.append('contact[tags]', 'newsletter,' + source);
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: body.toString()
    }).then(onDone).catch(onDone);
  }
  function validateEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim()); }

  /* ANNOUNCEMENT BAR EMAIL */
  var barForm = document.getElementById('barEmailForm');
  if (barForm) {
    barForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var inp = barForm.querySelector('input[type="email"]');
      if (!validateEmail(inp.value)) return;
      captureEmail(inp.value.trim(), 'announcement-bar', function() {
        inp.value = ''; inp.placeholder = 'code sent';
      });
    });
  }

  /* HERO EMAIL */
  var heroForm = document.getElementById('heroEmailForm');
  if (heroForm) {
    heroForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var inp = heroForm.querySelector('input[type="email"]');
      if (!validateEmail(inp.value)) return;
      captureEmail(inp.value.trim(), 'hero', function() {
        var note = document.querySelector('.hero-form .sub-note');
        inp.value = '';
        if (note) { note.textContent = 'Code sent - check your inbox.'; note.style.color = 'var(--red)'; }
      });
    });
  }

  /* MODAL HELPERS */
  function openModal(id) {
    var m = document.getElementById(id);
    if (m) { m.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }
  function closeModal(id) {
    var m = document.getElementById(id);
    if (m) { m.classList.remove('open'); document.body.style.overflow = ''; }
  }
  window.closeQuiz = function() { closeModal('quizModal'); };

  document.querySelectorAll('.modal-backdrop').forEach(function(m) {
    m.addEventListener('click', function(e) { if (e.target === m) closeModal(m.id); });
  });
  document.querySelectorAll('.modal-close').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var m = btn.closest('.modal-backdrop');
      if (m) closeModal(m.id);
    });
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal-backdrop.open').forEach(function(m) { closeModal(m.id); });
    }
  });
  document.querySelectorAll('[data-modal-close]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = btn.dataset.modalClose;
      closeModal(id);
      if (id === 'exitModal') { localStorage.setItem('axion_exit_shown', '1'); }
    });
  });

  /* STYLE QUIZ */
  document.querySelectorAll('[data-modal="quiz"]').forEach(function(t) {
    t.addEventListener('click', function() { openModal('quizModal'); initQuiz(); });
  });

  var QUIZ = [
    { id: 'space', q: 'How do you think about the wall?', sub: 'The piece lives there. What should it do?',
      options: [{ v: 'anchor', l: 'Anchor the room', desc: 'One strong composition, centre of gravity' },
                { v: 'provoke', l: 'Provoke thought', desc: 'Something to read, re-read, question' },
                { v: 'retreat', l: 'Hold the quiet', desc: 'Minimal - a rest for the eye' },
                { v: 'code', l: 'Signal identity', desc: 'Tells visitors who lives here' }] },
    { id: 'vocabulary', q: 'Which vocabulary speaks to you?', sub: 'Be precise.',
      options: [{ v: 'math', l: 'Mathematical', desc: 'Fibonacci, Golden ratio, Fractal' },
                { v: 'logic', l: 'Logical', desc: 'Axioms, Proofs, System diagrams' },
                { v: 'physics', l: 'Physics', desc: 'E=mc2, Quantum, Cosmology' },
                { v: 'geometry', l: 'Geometry', desc: 'Vesica Piscis, Penrose, Sacred' }] },
    { id: 'tone', q: 'Pick a tone.', sub: 'Gut feeling.',
      options: [{ v: 'stark', l: 'Stark', desc: 'Black, white, and one line' },
                { v: 'editorial', l: 'Editorial', desc: 'Typographic, measured, text-heavy' },
                { v: 'structural', l: 'Structural', desc: 'Grid, scaffold, system visible' },
                { v: 'cosmic', l: 'Cosmic', desc: 'Vast, quiet, scale-aware' }] },
    { id: 'objects', q: "What's on your desk?", sub: 'Tells us what you already know.', multi: true,
      options: [{ v: 'code', l: 'A terminal', desc: 'You speak to machines' },
                { v: 'books', l: 'Philosophy books', desc: 'Aurelius, Epictetus, Seneca' },
                { v: 'notebook', l: 'A grid notebook', desc: 'You plan in squares' },
                { v: 'coffee', l: 'Espresso, always', desc: 'Single origin, no exceptions' }] }
  ];
  var quizStep = 0, quizAnswers = {};

  function initQuiz() { quizStep = 0; quizAnswers = {}; renderQuiz(); }

  function renderQuiz() {
    var body = document.getElementById('quizBody');
    if (!body) return;
    updateProgress();
    if (quizStep < QUIZ.length) {
      var q = QUIZ[quizStep];
      var sel = quizAnswers[q.id];
      body.innerHTML =
        '<div class="mono" style="color:var(--slate);margin-bottom:10px">Section 0' + (quizStep+1) + ' of 0' + QUIZ.length + '</div>' +
        '<h2 style="font-family:var(--t-display);font-size:32px;font-weight:700;letter-spacing:-0.02em;margin-bottom:8px;color:var(--ink)">' + q.q + '</h2>' +
        '<p style="color:var(--slate);margin-bottom:0;font-size:14px">' + q.sub + '</p>' +
        '<div class="quiz-options">' +
          q.options.map(function(o) {
            var isSel = q.multi ? (Array.isArray(sel) && sel.indexOf(o.v) !== -1) : sel === o.v;
            return '<button class="quiz-option' + (isSel ? ' selected' : '') + '" data-v="' + o.v + '">' +
              '<div class="opt-title">' + o.l + '</div><div class="opt-desc">' + o.desc + '</div></button>';
          }).join('') +
        '</div>' +
        '<div class="quiz-nav">' +
          '<button class="back"' + (quizStep === 0 ? ' disabled style="opacity:0.3"' : '') + '>Back</button>' +
          (q.multi ? '<button class="btn-ink" style="font-size:13px;padding:10px 18px">Continue</button>' : '') +
        '</div>';
      body.querySelectorAll('.quiz-option').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var v = btn.dataset.v, q2 = QUIZ[quizStep];
          if (q2.multi) {
            var arr = quizAnswers[q2.id] || [];
            var idx = arr.indexOf(v);
            if (idx === -1) arr.push(v); else arr.splice(idx, 1);
            quizAnswers[q2.id] = arr; renderQuiz();
          } else { quizAnswers[q2.id] = v; setTimeout(function() { quizStep++; renderQuiz(); }, 200); }
        });
      });
      var back = body.querySelector('.back');
      if (back) back.addEventListener('click', function() { if (quizStep > 0) { quizStep--; renderQuiz(); } });
      var cont = body.querySelector('.btn-ink');
      if (cont) cont.addEventListener('click', function() {
        var q2 = QUIZ[quizStep];
        if (q2.multi && (!Array.isArray(quizAnswers[q2.id]) || !quizAnswers[q2.id].length)) return;
        quizStep++; renderQuiz();
      });
    } else if (quizStep === QUIZ.length) {
      body.innerHTML =
        '<div class="mono" style="color:var(--slate);margin-bottom:10px">Almost there</div>' +
        '<h2 style="font-family:var(--t-display);font-size:32px;font-weight:700;letter-spacing:-0.02em;margin-bottom:8px;color:var(--ink)">One last thing.</h2>' +
        '<p style="color:var(--slate);font-size:14px;margin-bottom:28px">We send your match plus a 10% code. Studio notes once a fortnight at most.</p>' +
        '<div style="border-bottom:1px solid var(--ink);display:flex;margin-bottom:8px">' +
          '<input id="quizEmailInp" type="email" placeholder="your@email.com" style="flex:1;background:transparent;border:none;outline:none;font-size:18px;padding:10px 0;color:var(--ink)">' +
        '</div>' +
        '<span id="quizEmailErr" style="color:var(--red);font-family:var(--t-mono);font-size:10px;letter-spacing:0.1em"></span>' +
        '<div class="quiz-nav" style="margin-top:24px">' +
          '<button class="back">Back</button>' +
          '<button class="btn-red" id="quizSubmitBtn">Send my match + code</button>' +
        '</div>';
      body.querySelector('.back').addEventListener('click', function() { quizStep--; renderQuiz(); });
      document.getElementById('quizSubmitBtn').addEventListener('click', function() {
        var inp = document.getElementById('quizEmailInp');
        if (!validateEmail(inp.value)) { document.getElementById('quizEmailErr').textContent = 'We need a real address.'; return; }
        captureEmail(inp.value.trim(), 'style-quiz', function() { quizStep = QUIZ.length + 1; renderQuiz(); });
      });
    } else {
      var map = { math: 'WA-01', logic: 'WA-27', physics: 'WA-15', geometry: 'WA-08' };
      body.innerHTML =
        '<div class="mono" style="color:var(--red);margin-bottom:8px">MATCH FOUND</div>' +
        '<h2 style="font-family:var(--t-display);font-size:32px;font-weight:700;letter-spacing:-0.02em;color:var(--ink);margin-bottom:12px">Your axis is locked.</h2>' +
        '<p style="color:var(--slate);font-size:14px;margin-bottom:24px">Code <strong style="font-family:var(--t-mono);color:var(--ink)">AXION10</strong> is on its way. Valid 7 days.</p>' +
        '<div style="padding:16px;background:var(--paper-2);margin-bottom:20px;font-family:var(--t-mono);font-size:11px;letter-spacing:0.15em;color:var(--slate)">Piece ref: ' + (map[quizAnswers.vocabulary] || 'WA-25') + '</div>' +
        '<a href="/collections/all" class="btn-ink" style="text-decoration:none" onclick="closeQuiz()">Explore the catalogue</a>';
    }
  }
  function updateProgress() {
    document.querySelectorAll('#quizModal .quiz-progress span').forEach(function(b, i) {
      b.classList.toggle('done', i <= quizStep);
    });
  }

  /* EXIT-INTENT / DWELL (Fix 8 — softened for cold paid traffic) */
  var exitShown = localStorage.getItem('axion_exit_shown');
  if (!exitShown) {
    var pageStart = Date.now();
    /* dwell trigger raised 10s -> 45s so it never interrupts an engaged reader */
    var dwellTimer = setTimeout(function() { openModal('exitModal'); exitShown = '1'; }, 45000);
    /* desktop exit-intent only: cursor leaves top of viewport AND >=8s on page.
       (scroll-after-2s auto-popup removed — it punished engaged scrollers; mobile
       has no mouseleave so it only ever sees the 45s dwell.) */
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 0 && !exitShown && (Date.now() - pageStart) > 8000) {
        openModal('exitModal'); clearTimeout(dwellTimer); exitShown = '1';
      }
    });
  }
  var exitForm = document.getElementById('exitEmailForm');
  if (exitForm) {
    exitForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var inp = exitForm.querySelector('input[type="email"]');
      if (!validateEmail(inp.value)) return;
      captureEmail(inp.value.trim(), 'exit-intent', function() {
        localStorage.setItem('axion_exit_shown', '1');
        var s = document.getElementById('exitSuccess');
        if (s) { s.style.display = 'block'; exitForm.style.display = 'none'; }
      });
    });
  }

  /* NOTIFY-ME FORMS */
  document.querySelectorAll('.notify-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var inp = form.querySelector('input[type="email"]');
      if (!validateEmail(inp.value)) return;
      captureEmail(inp.value.trim(), 'notify-' + (form.dataset.category || 'waitlist'), function() {
        inp.value = ''; inp.placeholder = 'added to list';
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.textContent = 'Done'; }
      });
    });
  });
  document.querySelectorAll('.card-notify').forEach(function(row) {
    var btn = row.querySelector('button');
    var inp = row.querySelector('input[type="email"]');
    if (!btn || !inp) return;
    btn.addEventListener('click', function() {
      if (!validateEmail(inp.value)) { inp.focus(); return; }
      captureEmail(inp.value.trim(), 'notify-' + (row.dataset.category || 'waitlist'), function() {
        inp.value = ''; inp.placeholder = 'on the list'; btn.textContent = 'Done';
      });
    });
    inp.addEventListener('keydown', function(e) { if (e.key === 'Enter') btn.click(); });
  });

  /* SMOOTH ANCHOR SCROLL */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var id = a.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* CART COUNT BADGE (Fix 7) — runs on every page so the nav bag always reflects the cart */
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var el = document.getElementById('cart-badge');
      if (el && cart.item_count > 0) { el.textContent = cart.item_count; el.style.display = 'flex'; }
    })
    .catch(function () {});

})();

